import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import {
  getDocument,
  updateMeasurmentSheetApi,
} from "../../../../../services/DocumentService";
import { StaticSelectInput } from "../../../../constant/SelectInput";

const EditMeasurementSheet = () => {
  const [dataInput, setDataInput] = useState({
    title: "",
    document_id: null,
  });
  const [parameter, setParameter] = useState([]);
  const [errors, setErrors] = useState({});
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [document, setDocument] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const id = location.state?.id || "";
  const data = location.state?.data || {};
  const updateActiveKey = location.state?.updateActiveKey || "";

  useEffect(() => {
    if (data) {
      setDataInput({
        title: data.title || "",
        document_id: data.document?.id || null,
      });

      const parameters = data.parameters || [];
      setParameter(
        parameters.map((item) => ({
          parameter_id: item.id || "",
          parameter_name: item.parameter_name || "",
          expected_value: item.expected_value || "",
        }))
      );
    }
  }, [data]);

  useEffect(() => {
    const fetchDocument = async () => {
      try {
        const resp = await getDocument();
        setDocument(resp.data.data || []);
      } catch (error) {
        console.error("Error fetching documents:", error);
      }
    };

    fetchDocument();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    setDataInput((prevDataInput) => ({ ...prevDataInput, [name]: value }));
  };

  const handleSelectChange = (name, value) => {
    setDataInput((prev) => ({ ...prev, [name]: value }));
  };

  const handleDynamicChange = (index, field, value) => {
    const updatedFields = [...parameter];
    updatedFields[index][field] = value;
    setParameter(updatedFields);
  };

  const addDynamicField = () => {
    setParameter([...parameter, { parameter_name: "", expected_value: "" }]);
  };

  const removeDynamicField = (index) => {
    const updatedFields = [...parameter];
    updatedFields.splice(index, 1);
    setParameter(updatedFields);
  };

  const validateInputs = () => {
    const validationErrors = {};
    if (!dataInput.title) validationErrors.title = "Document Title is required";
    if (!dataInput.document_id)
      validationErrors.document_id = "Document Type is required";

    const dynamicErrors = parameter.some(
      (field) => !field.parameter_name || !field.expected_value
    );
    if (dynamicErrors) {
      validationErrors.parameter = "All dynamic fields are required";
    }

    return validationErrors;
  };

  const handleSubmit = async () => {
    const validationErrors = validateInputs();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      setIsSubmitLoading(true);
      const payload = {
        ...dataInput,
        parameter,
      };
      const response = await updateMeasurmentSheetApi(data.id, payload);
      toast.success(response.data.message);
      if (updateActiveKey) {
        navigate(`/document/${id}`, {
          state: { activekey: updateActiveKey },
        });
      } else {
        navigate("/te-sheet");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong!");
    } finally {
      setIsSubmitLoading(false);
    }
  };

  const handleCancel = () => {
    if (updateActiveKey) {
      navigate(`/document/${id}`, {
        state: { activekey: updateActiveKey },
      });
    } else {
      navigate("/te-sheet");
    }
  };

  return (
    <div className="container-fluid">
      <div className="row px-sm-2 px-0">
        <div className="col-xl-12">
          <div className="card px-sm-3 px-1">
            <div className="card-body">
            <div className="d-flex align-items-center mb-4">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm btn-circle"
                    onClick={handleCancel}
                  >
                    <i className="fa-solid fa-arrow-left"></i>
                  </button>
                  <h3 className="mb-0 ms-2">Edit TE-Sheet</h3>
                </div>
              <form>
                <div className="row mb-2">
                  <div className="col-md-6">
                    <div className="form-group mb-3">
                      <label className="form-label">
                        Title<span className="text-danger">*</span>
                      </label>
                      <input
                        className="form-control mb-3"
                        placeholder="Enter Title"
                        name="title"
                        value={dataInput.title}
                        onChange={handleChange}
                      />
                      {errors.title && (
                        <div className="text-danger">{errors.title}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group mb-3">
                      <StaticSelectInput
                        setParentInputValue={handleSelectChange}
                        optionsList={document.map((item) => ({
                          value: item.id,
                          label: item.title,
                        }))}
                        name="document_id"
                        id="document_id"
                        isClearable
                        placeholder="Select Document"
                        label="Document"
                        isRequired={true}
                        defaultValue={{
                          value: data.document.id,
                          label: data.document.title,
                        }}
                      />
                      {errors.document_id && (
                        <div className="text-danger">{errors.document_id}</div>
                      )}
                    </div>
                  </div>
                </div>

                <h5 className="mb-3">
                  Parameter <span className="text-danger">*</span>
                </h5>
                {parameter.map((field, index) => (
                  <div className="row mb-4" key={index}>
                    <div className="col-md-6">
                      <input
                        className="form-control"
                        placeholder="Parameter Name"
                        value={field.parameter_name}
                        onChange={(e) =>
                          handleDynamicChange(
                            index,
                            "parameter_name",
                            e.target.value
                          )
                        }
                      />
                    </div>
                    <div className="col-md-4">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Expected Value"
                        value={field.expected_value}
                        onChange={(e) =>
                          handleDynamicChange(
                            index,
                            "expected_value",
                            e.target.value
                          )
                        }
                      />
                    </div>
                    <div className="col-md-2 d-flex align-items-center">
                      {index === parameter.length - 1 && (
                        <button
                          type="button"
                          className="btn btn-success btn-sm me-2"
                          onClick={addDynamicField}
                        >
                          +
                        </button>
                      )}
                      {parameter.length > 1 && (
                        <button
                          type="button"
                          className="btn btn-danger btn-sm"
                          onClick={() => removeDynamicField(index)}
                        >
                          -
                        </button>
                      )}
                    </div>
                    {errors.parameter && (
                      <div className="text-danger mb-2 mt-2">
                        {errors.parameter}
                      </div>
                    )}
                  </div>
                ))}

                <div className="d-flex align-items-center justify-content-start">
                  <button
                    type="button"
                    className="btn btn-primary me-3"
                    onClick={handleSubmit}
                    disabled={isSubmitLoading}
                  >
                    {isSubmitLoading ? "Submitting..." : "Submit"}
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditMeasurementSheet;
